import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(3px);
  z-index: 1000;

  &.overlay-part-2 {
    position: relative;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(3px);
    z-index: 1000;

    /* Remove background-color and backdrop-filter here 
       since we move it into a layered overlay */
    background-color: transparent;
    backdrop-filter: none;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background-image: url("/assets/map.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      filter: blur(3px);
      z-index: -2;
    }

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.7); /* Dark overlay on top of blurred image */
      z-index: -1;
    }
  }
`;
